import React from 'react'
import Product from '../ProductDetail/Product'

const Women = () => {
  return (
    <div>
      <Product url="women"/>
    </div>
  )
}

export default Women